module.exports = __webpack_public_path__ + "img/top.ad292ec8.png";